import { createSlice } from '@reduxjs/toolkit';
import { getRegionControlListThunk } from './RegionControl.thunk';
import { RegionControlState } from './RegionControl.type';
import { RootState } from '../../store';

const SLICE_NAME = 'regionControl';

const initialState: RegionControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const regionControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setRegionControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getRegionControlListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getRegionControlListThunk.fulfilled,
      (state, { payload }) => {
        const { data, pagination } = payload;
        state.isLoading = false;
        state.items = data;
        state.pagination = {
          currentPage: pagination.current_page,
          lastPage: pagination.last_page,
          perPage: pagination.per_page,
          from: pagination.from,
          to: pagination.to,
          total: pagination.total,
        };
      },
    );
    builder.addCase(getRegionControlListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const {
  setRegionControlList
} = regionControlSlice.actions;

export const getRegionControlList = (state: RootState) =>
  state.regionControl.items;

export const getRegionControlListPagination = (state: RootState) =>
  state.regionControl.pagination;

export default regionControlSlice.reducer;
